import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useThemeColors } from '@/hooks/shared/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  rightAction?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = React.memo(({ title, subtitle, rightAction }) => {
  const { colors } = useThemeColors();

  return (
    <View style={styles.container}>
      <View style={styles.titleRow}>
        <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
        {rightAction}
      </View>
      {subtitle ? <Text style={[styles.subtitle, { color: colors.text.dim }]}>{subtitle}</Text> : null}
    </View>
  );
});

PageHeader.displayName = 'PageHeader';

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    paddingBottom: 20,
    gap: 4,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.heading1,
  },
  subtitle: {
    ...REDESIGN_TYPOGRAPHY.body,
  },
});
